import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # TooltipItem
 *
 * TooltipItem을 설명하세요.
 */
export const TooltipItem = types
  .model('TooltipItem')
  // --------------------------------------------------------------------------
  .props({
    amt: types.maybeNull(types.number),
    projectName: types.maybeNull(types.string),
    projectSid: types.maybeNull(types.number),
    startDay: types.maybeNull(types.number),
    endDay: types.maybeNull(types.number),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model tooltipItem --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ITooltipItem;
      (Object.keys(newProps) as TTooltipItemKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TTooltipItem = Instance<typeof TooltipItem>;
type TTooltipItemSnapshot = SnapshotOut<typeof TooltipItem>;

export interface ITooltipItem extends TTooltipItem {}
export type TTooltipItemKeys = keyof TTooltipItemSnapshot & string;
export interface ITooltipItemSnapshot extends TTooltipItemSnapshot {}
export const createTooltipItem = () => types.optional(TooltipItem, {} as TTooltipItem);
